<template>
  <table class="my-release-list__table">
    <thead>
      <tr style="text-align: left;">
        <th>分配率</th>
        <th>
          メンバー
        </th>
        <th>メモ</th>
        <th>役割</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in form"
        :key="item.email">
        <td>{{ item.rate }}%</td>
        <td class="memo">
          {{ item.email }}
        </td>
        <td class="memo">{{ item.memo }}</td>
        <td>{{ item.role.role }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'RevenueShareFormTable',
  props: {
    form: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.my-release-list__table th {
  width: 100px;
}
.memo {
  width: 30%;
  word-break: break-all;
  padding-right: 8%;
}
</style>
